import { toast } from 'sonner';

export interface OpenWindowOptions {
  target?: string;
  features?: string;
  blockedMessage?: string;
  fallbackMessage?: string;
}

/**
 * Open a URL safely. If the browser blocks the requested popup/window,
 * fall back to a plain new tab and notify the user via toast.
 *
 * Returns the opened Window (or null if even the fallback was blocked).
 */
export function openWindowSafe(url: string, options: OpenWindowOptions = {}): Window | null {
  const {
    target = '_blank',
    features,
    blockedMessage = 'Popup was blocked — opened in a new tab instead.',
    fallbackMessage = 'Popup was blocked, click here to continue.',
  } = options;

  const primary = window.open(url, target, features);
  if (primary && !primary.closed) return primary;

  const fallback = window.open(url, '_blank');
  if (fallback && !fallback.closed) {
    toast.info(blockedMessage);
    return fallback;
  }

  toast.error(fallbackMessage, {
    duration: 10000,
    action: {
      label: 'Continue',
      onClick: () => window.open(url, '_blank'),
    },
  });
  return null;
}
